import LOCAL_KEYS, { parseLocalStorageJSON } from "../../../helpers/Localstorage";
import { RequestBody } from "../../WebServiceManager/RequestBody";
import { RequestHeader } from "../../WebServiceManager/RequestHeader";

export default class ProfileRequestBody {

  updateProfileUserRequest(method,obj) {
    const header = new RequestHeader();
    const request = new RequestBody(
      method,
      header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
      obj
    );

    return request;
  }

  uploadProfilePictureRequest(method,obj) {
    const header = new RequestHeader();
    const request = new RequestBody(
      method,
      header.multiPartData(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
      obj
    );
    return request;
  }

  getProfilePictureRequest(method) {
    const header = new RequestHeader();
    const request = new RequestBody(
      method,
      header.multiPartData(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
    );
    return request;
  }

  uploadCoverImageRequest(method,obj) {
    const header = new RequestHeader();
    const request = new RequestBody(
      method,
      header.multiPartData(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
      obj
    );
    return request;
  }

  getCoverImageRequest(method) {
    const header = new RequestHeader();
    const request = new RequestBody(
      method,
      header.multiPartData(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
    );
    return request;
    };
}
